var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-mobile",on:{"click":_vm.logout}},[_c('span',{staticClass:"nav-item nav-link span-nav-mobile"},[_c('md-icon',[_vm._v("logout")]),_vm._v("Sair")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }